import Vue from 'vue'
import { createPinia, PiniaVuePlugin } from "pinia";
import App from './App.vue'
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from "vue-session"
import { routes } from './routes';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { i18n } from  './lang/lang'
import './assets/scss/theme.scss';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'video.js/dist/video-js.css'
import 'animate.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
// import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'material-symbols/index.css';

import PortalVue from 'portal-vue'




// Import only the icons you need
import {
  faGripVertical,
  faTimes,        // Replaces faXmark and faClose
  faTh,           // Replaces faTableCells
  faBars,
  faPlus,
  faFilm,
  faUser,
  faBuilding,       // organization
  faHardDrive,      // device
  faSquareRootAlt,  // variable (pick one that fits)
  faGaugeHigh,      // dashboard
  faRuler,          // measurer
  faUsers,          // group
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faGripVertical,
  faTimes,
  faTh,
  faBars,
  faPlus,
  faFilm,
  faUser,
  faBuilding,       // organization
  faHardDrive,      // device
  faSquareRootAlt,  // variable (pick one that fits)
  faGaugeHigh,      // dashboard
  faRuler,          // measurer
  faUsers,          // group
)



//../../components/legacy/shared/Input/SelectInput.vue
import SelectInput                        from "../src/components/legacy/shared/Input/SelectInput.vue"
import TextInput                          from "../src/components/legacy/shared/Input/TextInput.vue"
import FileInput                          from "../src/components/legacy/shared/Input/FileInput.vue"
import Button                             from "../src/components/legacy/shared/button/MtwButton.vue"
import Label                              from "../src/components/legacy/shared/label/Label.vue"
import Modal                              from "../src/components/legacy/shared/modal/Modal.vue"
import ConfirmDeleteModal                 from "../src/components/legacy/shared/modal/ConfirmDeleteModal.vue"
import ModalUser                          from "../src/components/legacy/shared/modal/ModalUser.vue"
import Sidebar                            from "../src/components/legacy/shared/sidebar/TransparentSidebar.vue"
import HeadNavWithLogo                    from "../src/components/legacy/shared/navbar/HeadNavWithLogo.vue"
import RelationTable                      from "../src/components/legacy/shared/table/RelationTableWithBorders.vue"
import TableBordered                      from "../src/components/legacy/shared/table/TableBordered.vue"
import PageHeader                         from "../src/components/legacy/shared/misc/PageHeader.vue"
import ObjectSelect                       from "../src/components/legacy/shared/select/ObjectSelectWithSearch.vue"
import Checkbox                           from "../src/components/legacy/shared/checkbox/Checkbox.vue"
import Slider                             from "../src/components/legacy/shared/Input/SliderInput.vue"
import TabPage                            from "../src/components/legacy/shared/tabpage/TabPage.vue"
import card                               from "../src/components/legacy/shared/card/CardInfo.vue"
import CnpjCpfInput                       from "../src/components/legacy/shared/Input/SelectCpfOrCnpjInput.vue"
import TableSelectAlarmPriorityColor      from '../src/components/legacy/shared/table/TableSelectAlarmPriorityColor.vue'
import CsvInput                           from "../src/components/legacy/shared/Input/CsvInput.vue"
import PhotoMotion                        from "../src/components/legacy/shared/photoMotion/PhotoMotion.vue"

import BarChart                           from "../src/components/legacy/shared/d3/BarChart.vue"
import StackedBarChart                    from "../src/components/legacy/shared/d3/StackedBarChart.vue"
import MultipleLineChart                  from "../src/components/legacy/shared/d3/MultipleLineChart.vue"
import UtilsTelemetry                     from "../src/utils-telemetry"
import SimpleTable                        from "../src/components/legacy/shared/table/simpleTable/index.vue"
import DateTimeRangePicker                from "../src/components/legacy/shared/DateTimeRangePicker.vue"; 



Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(PortalVue);

Vue.use(PiniaVuePlugin);

const pinia = createPinia();

Vue.use(IconsPlugin);
Vue.use(VueAxios, axios);
Vue.use(VueSession);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 6,
  newestOnTop: true
});


Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('vue-select', vSelect)
Vue.component('select-input', SelectInput)
Vue.component('text-input', TextInput)
Vue.component('file-input', FileInput)
Vue.component('action-button', Button)
Vue.component('text-label', Label)
Vue.component('info-modal', Modal)
Vue.component('confirm-delete-modal', ConfirmDeleteModal)
Vue.component('test-modal', ModalUser)
Vue.component('menu-sidebar', Sidebar)
Vue.component('logo-headNav', HeadNavWithLogo)
Vue.component('relation-table', RelationTable)
Vue.component('info-table', TableBordered)
Vue.component('page-header', PageHeader)
Vue.component('object-select', ObjectSelect)
Vue.component('checkbox', Checkbox)
Vue.component("date-picker", DatePicker)
Vue.component("tab-page", TabPage)
Vue.component("BarChart", BarChart)
Vue.component("StackedBarChart", StackedBarChart)
Vue.component('Slider', Slider)
Vue.component('card', card);
Vue.component('cpf-cnpj-input', CnpjCpfInput);
Vue.component('select-color-table', TableSelectAlarmPriorityColor);
Vue.component("csv-input", CsvInput)
Vue.component("photo-motion", PhotoMotion);
Vue.component("multiple-line-chart", MultipleLineChart);
Vue.component('simple-table', SimpleTable)
Vue.component('date-time-range-picker', DateTimeRangePicker);





Vue.use(VueSidebarMenu)

Vue.directive('th-resizeCard', {
  bind: function(el, binding){
    setInterval(()=>{
      if(!el.dataset.lastWidth || !el.dataset.lastHeight){
        el.dataset.lastWidth = el.offsetWidth
        el.dataset.lastHeight = el.offsetHeight
      }else{
        if(el.dataset.lastWidth != el.offsetWidth || el.dataset.lastHeight != el.offsetHeight){
          el.dataset.lastWidth = el.offsetWidth
          el.dataset.lastHeight = el.offsetHeight
          binding.value(el.offsetWidth, el.offsetHeight)
        }
      }
    }, 100)
  }
})

const router = new VueRouter({ 
  routes, 
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  i18n.locale = localStorage.getItem('language') || 'en'
  return next()
})

var utilsTelemetry = new UtilsTelemetry(Vue);
utilsTelemetry.addAllPrototye(Vue).then(()=>{
  utilsTelemetry.addAllComponents(Vue)
  new Vue({
    pinia,
    el: '#app',
    router,
    i18n,
    render: h => h(App),
  })

  Vue.directive('th-disableLowPrivilegeBtn', {
    bind(el){
      const privilege = Vue.prototype.$session.get("user").privilege
      if(privilege == 2){
        el.setAttribute('disabled', '')
      }
    }
  })
});

